document.addEventListener('DOMContentLoaded', () => {
  // En el editor de temas no animamos, para que puedas editar sin que se oculte nada
  if (window.Shopify && Shopify.designMode) return;

  const sections = document.querySelectorAll('.shopify-section');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  sections.forEach((section, i) => {
    if (i === 0) return; // deja el primer bloque (header/hero) sin animar
    section.classList.add('fade-in-ready');
    observer.observe(section);
  });
});